import DailyPreciptation from "./DailyPreciptation";

export default DailyPreciptation;